import * as React from "react"
import { Button } from "../../tiptap-ui-primitive/button"
import { ImageIcon } from "../../tiptap-icons/image-icon"
import { useTiptapEditor } from "../../hooks/use-tiptap-editor"
import { isExtensionAvailable } from "../../lib/tiptap-utils"

export interface ImageUploadButtonProps {
  text?: string
}

export const ImageUploadButton: React.FC<ImageUploadButtonProps> = ({ text }) => {
  const editor = useTiptapEditor()

  const canInsert = React.useMemo(() => {
    if (!editor || !editor.isEditable) return false
    if (!isExtensionAvailable(editor, "imageUpload")) return false
    return editor.can().insertContent({ type: "imageUpload" })
  }, [editor])

  const handleClick = () => {
    if (!editor || !canInsert) return
    editor.chain().focus().setImageUploadNode().run()
  }

  return (
    <Button
      onClick={handleClick}
      data-disabled={!canInsert}
      disabled={!canInsert}
      aria-label="Добавить изображение"
      title="Добавить изображение"
    >
      <ImageIcon className="tiptap-button-icon" />
      {text && <span>{text}</span>}
    </Button>
  )
}
